import { useTranslation } from 'react-i18next';
import * as Styled from './Footer.styles';
import logo from '../../global/media/footer-logo.svg';
import whatsappLogo from '../../global/media/footer-whatsapp-icon.svg';
import phoneIcon from '../../global/media/footer-phone-icon.svg';

const Footer = () => {
  const { t } = useTranslation();

  const icons = [
    {
      key: 'whatsapp',
      icon: whatsappLogo,
      route: process.env.REACT_APP_WHATSAPP_URL,
    },
  ];

  return (
    <Styled.FooterContainer>
      <Styled.FooterContentContainer>
        <Styled.FooterContentBlock>
          <Styled.FooterLeftBlock>
            <img src={logo} alt="application logo" />
            <div className="description">{t('Footer.DESCRIPTION')}</div>
          </Styled.FooterLeftBlock>
          <Styled.FooterRightBlock>
            <Styled.FooterLinks>
              {icons.map((item) => (
                <a href={`${item.route}`} key={item.key}>
                  <img src={item.icon} alt={item.key} className="icon" />
                </a>
              ))}
            </Styled.FooterLinks>
            <Styled.FooterPhone>
              <div className="icon">
                <a href={`tel: ${process.env.REACT_APP_CONTACT_NUMBER}`}>
                  <img src={phoneIcon} alt="phone icon" />
                </a>
              </div>
              <a href={`tel: ${process.env.REACT_APP_CONTACT_NUMBER}`}>
                {process.env.REACT_APP_CONTACT_NUMBER}
              </a>
            </Styled.FooterPhone>
          </Styled.FooterRightBlock>
        </Styled.FooterContentBlock>
      </Styled.FooterContentContainer>
    </Styled.FooterContainer>
  );
};

export default Footer;
